import { ColumnTitle } from '@atoms/columnElement';
import { RenderSource } from '@atoms/dataSelectors/sourceSelector/renderSource';
import { SourceSelector } from '@atoms/dataSelectors/sourceSelector/sourceSelector';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { EditorOptions } from '@library/tableEditor/shared/editor.options';
import type { AtomModel } from '@models/atom.model';
import type { TableEditorSelectColumnData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  atom: AtomModel<TableEditorSelectColumnData>;
};

export const SelectEditor = observer(({ atom }: Props) => (
  <EditorOptions
    additionalChildren={
      <Column $width="220px">
        <ColumnTitle>Sources options</ColumnTitle>
        <RenderSource
          id={atom.id}
          onSourceDataChange={v =>
            (atom.data.editorOptions.editors.select.options.dataSourceData = v)
          }
          selectedDataSource={
            atom.data.editorOptions.editors.select.options.dataSource
          }
          sourcesData={
            atom.data.editorOptions.editors.select.options.dataSourceData
          }
        />
      </Column>
    }
    atomId={atom.id}
    onPlaceholderChange={v =>
      (atom.data.editorOptions.editors.select.placeholder = v)
    }
    placeholder={atom.data.editorOptions.editors.select.placeholder}
  >
    <SourceSelector
      dataSource={atom.data.editorOptions.editors.select.options.dataSource}
      id={atom.id}
      onDataSourceChange={v =>
        (atom.data.editorOptions.editors.select.options.dataSource = v)
      }
      possibleSources={['normalSource', 'database', 'stateVariable']}
    />
  </EditorOptions>
));
